import React, {Component} from 'react';
import {connect} from "react-redux";

class EidWrongPin extends Component {

    render() {
        if (!this.props.wrongPin)
            return null;

        return (
            <div id="eid-wrong-pin" className="alert alert-error">
                <span class="kc-feedback-text">
                    {window.eidMessages.wrongPin} {this.props.wrongPin.triesLeft}
                </span>
            </div>
        )
    }

}

export default connect(
    (state) => {
        return {
            wrongPin: state.eid.wrongPin
        }
    },
    (dispatch) => {
        return {
            
        }
    }
)(EidWrongPin);


// WEBPACK FOOTER //
// ./src/components/EidWrongPin.js